import modulo from '@/utils/modulo'
import axios from '@/utils/api'

const actions = {
  async getListCredenciados ({ commit }) {
    return axios({
      url: `${modulo.PUBLICO}/api/v1/credenciado`,
      method: 'GET'
    })
  }
}
export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/listagemProcesso.js